import React from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { usePortalAuth } from "../../contexts/PortalAuthContext"; 

function PortalTopNav() {
  const { logout, portalUser } = usePortalAuth();
  return (
    <div className="top-bar">
      <div className="dropdown float-end">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            {portalUser?.email}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={logout}>
              <FontAwesomeIcon className="px-2" icon={faArrowRightFromBracket} />Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default PortalTopNav;
